export default __webpack_public_path__ + "static/media/footer-maps.4500cb2a.webp";